var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-container"},[_c('b-button',{attrs:{"variant":"outline-success"},on:{"click":_vm.redirectToPreviewTickets}},[_vm._v(" "+_vm._s(_vm.$t('Success.previewTickets'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }